import { set, isFunction, extend, isString, startsWith, get } from 'lodash';
import axios from 'axios';
import debug from 'debug';
import Vue from 'vue';
const isNode = typeof window === 'undefined';
if (isNode)
    set(global, 'window', {});
import * as VueKeyCloak from '@dsb-norge/vue-keycloak-js';
if (isNode)
    delete global.window;
const log = debug('itp:core:auth');
export class Auth {
    kc;
    $user;
    url;
    options;
    accountUrl;
    constructor(options) {
        log('instantiating auth: %o', options);
        this.options = options;
        this.$user = {
            id: '',
            userName: '',
            fullName: undefined,
            email: ''
        };
        this.url = this.urlFromOptions(options);
        this.accountUrl = `${this.url}/realms/${options.realm}/account`;
    }
    urlFromOptions(options) {
        if (options.url) {
            return options.url;
        }
        const loc = window.location;
        const path = options.path;
        if (isString(path)) {
            if (startsWith(path, "http")) {
                return path;
            }
            return `${loc.origin}${path}`;
        }
        throw Error("Missing keycloak path.");
    }
    get user() {
        return this.$user;
    }
    get token() {
        return this.kc.token;
    }
    init() {
        const self = this;
        return new Promise((resolve, reject) => {
            log('initializing kc...');
            const config = { ...this.options, url: this.url, }, init = {
                onLoad: 'login-required',
                checkLoginIframe: false,
                enableLogging: true,
                useNonce: false
            };
            log('config: %o, init: %o', config, init);
            Vue.use(VueKeyCloak, {
                config,
                init,
                onReady(kc) {
                    self.kc = kc;
                    log('kc connection success');
                    self.setupTokenInterceptor(kc);
                    Promise.resolve(self.loadUserData()).then(() => resolve(kc));
                },
                onInitError(error, err) {
                    log('kc connection error. %o (%o)', error, err);
                    reject(error);
                },
                onAuthSuccess() {
                    log('auth success');
                    self.loadUserData().catch(error => reject(error));
                }
            });
        });
    }
    callLogout(fun) {
        const redirectUri = document.URL;
        return fun.call(this.kc, { redirectUri });
    }
    logout() {
        const logout_func = get(this.kc, 'logout', null);
        if (isFunction(logout_func)) {
            return this.callLogout(logout_func);
        }
        log('logging out...');
        if (this.kc.logoutFn) {
            this.kc.logoutFn();
        }
        else {
            const redirectUri = document.URL;
            console.warn(`Missing keycloak logout function. Logging out with redirectUri ${redirectUri}`);
            this.kc.keycloak?.logout({ redirectUri }).then(res => console.log(res)).catch(err => console.error(err));
        }
    }
    setupTokenInterceptor(keycloak) {
        axios.interceptors.request.use(config => {
            if (config && config.headers) {
                config.headers.Authorization = `Bearer ${keycloak.token}`;
            }
            return config;
        }, error => Promise.reject(error));
    }
    loadUserData() {
        if (this.kc.loadUserProfile) {
            return this.kc.loadUserProfile().then(p => (this.setUserData(p), p));
        }
        console.warn('loadUserProfile function is missing from Keycloak instance.');
        return Promise.resolve(null);
    }
    setUserData(profile) {
        extend(this.$user, {
            id: profile.id,
            userName: profile.username,
            fullName: [profile.firstName, profile.lastName]
                .filter(p => !!p)
                .join(' '),
            email: profile.email
        });
        log('user: %o', this.user);
    }
}
export class FakeAuth {
    token;
    user;
    accountUrl;
    constructor(options) {
        this.token = options.token;
        this.user = options.userData || {
            id: 'test',
            userName: 'testuser',
            fullName: 'Test Joe',
            email: 'johndoe@domain.com'
        };
        if (isString(options.accountUrl)) {
            this.accountUrl = options.accountUrl;
        }
    }
    init() {
        this.setupTokenInterceptor();
        return Promise.resolve();
    }
    logout() { }
    setupTokenInterceptor() {
        axios.interceptors.request.use(config => {
            if (config.headers) {
                config.headers.Authorization = `Bearer ${this.token}`;
            }
            return config;
        }, error => Promise.reject(error));
    }
}
//# sourceMappingURL=auth.js.map